(function () {
    "use strict";

    // @ngInject
    function AdminLoginControllerCtor(UsersManager, AnalyticsService, RepositoryService,
                                      $scope, $injector, $window, $document, $timeout) {

        this.constructor.$super.call(this, $scope, $injector);

        this.UsersManager = UsersManager;
        this.AnalyticsService = AnalyticsService;
        this.RepositoryService = RepositoryService;

        this.__objectType = 'AdminLoginController';
        this.$window = $window;

        this.user = UsersManager.newUser();
        this.isMalkut = UsersManager.getCurrUser().isMalkut();
        this.admin_token = UsersManager.getCurrUser().id();
        this.$timeout = $timeout;
        this.$document = $document;
        this.mfaNeeded = false;

        //We now load a script that is only needed for admins to reduce bundle size for users
        var script = document.querySelector("script[src*='https://cdnjs.cloudflare.com/ajax/libs/qrcode-generator/1.4.4/qrcode.min.js']");
        if (!script) {
            var heads = document.getElementsByTagName("head");
            if (heads && heads.length) {
                var head = heads[0];
                if (head) {
                    script = document.createElement('script');
                    script.setAttribute('src', 'https://cdnjs.cloudflare.com/ajax/libs/qrcode-generator/1.4.4/qrcode.min.js');
                    script.setAttribute('type', 'text/javascript');
                    head.appendChild(script);
                }
            }
        }
    }


    Controllers.AdminLoginController = Class(Controllers.BaseController, {

        constructor: AdminLoginControllerCtor,
        goToMalkut: function () {
            var self = this;
            self.UsersManager.getMalkutUrl().then(
                function success(resp) {
                    self.UsersManager.logout().then(function afterLogout() {
                        self.$window.location.href = resp.data.url;
                    });
                },
                function error(resp) {
                    self.lastError = resp.data.error_message || resp.data;
                }
            );
        },
        login: function login() {

            this.UsersManager.adminLogin(this.email, this.mfa).then(
                function success(resp) {
                    var currUser = this.UsersManager.getCurrUser();
                    currUser.is_hb_admin = true;
                    currUser.admin_token = this.admin_token;
                    this.AnalyticsService.unidentify();
                    this.AnalyticsService.identify(currUser);
                    this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.admin_login_as);

                    var nextState = this.AppStates.root_core_navigation_dashboard;
                    if (this.user.isAdmin()) {
                        nextState = this.AppStates.root_core_admin_login;
                    } else if (this.user.isMalkut()) {
                        nextState = this.AppStates.root_malkut_cs;
                    }
                    this.goToState(nextState);
                }.bind(this),
                function error(resp) {
                    if(resp.data.error_type == 'HBUserLoginFailedError' && !this.mfaNeeded){

                        if(resp.data.error_message && resp.data.error_message.indexOf("otpauth://") !== -1){
                            this.qrUri = resp.data.error_message.slice(resp.data.error_message.indexOf("otpauth://"));

                            this.$timeout(this.setQrCode.bind(this), 100);

                        }
                        this.mfaNeeded = true;
                    }else{
                        this.lastError = resp.data.error_message || resp.data;
                    }

                }.bind(this)
            );
        },

        setQrCode: function setQrCode() {

            var qr = qrcode(8, 'L');
            qr.addData(this.qrUri, 'Byte');
            qr.make();
            document.getElementById('qr-placeholder').innerHTML = qr.createImgTag(4);
        }


    });
}());

